import { csvParseRows } from 'd3-dsv';

function loadData(id) {
  const filename = `${process.env.BASE_URL}data/${id}.csv`;

  return new Promise((resolve) => {
    fetch(filename)
      .then(response => response.text())
      .then(text => csvParse(text))
      .then((data) => {
        let map = data.reduce((map, d) => {
          // convert to ints
          const rowData = [d[1], +d[2], +d[3], +d[4], +d[5]];
          map.has(d[0]) ? map.get(d[0]).push(rowData) : map.set(d[0], [rowData]);
          return map;
        }, new Map())

        resolve(map);
      });
  })
}

function csvParse(text) {
  return csvParseRows(text, (row, i) => {
    if (i === 0) {
      return;
    }
    return row;
  });
}

export default loadData;
